import { Component, inject, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@src/app/shared/shared.module';
import { HunterAgentSettingsComponent } from '@src/app/modules/meme-dashboard/components/hunter-agent-settings/hunter-agent-settings.component';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { CommonService } from '@src/app/services/common.service';
import { MyProfileService } from '@src/app/modules/my-profile/my-profile.service';
import { MemeStarSettingsComponent } from '@src/app/modules/meme-dashboard/components/meme-star-settings/meme-star-settings.component';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { MemeDashboardService } from '@src/app/modules/meme-dashboard/meme-dashboard.service';
import { MemeDashboardStatusService } from '@src/app/modules/meme-dashboard/meme-dashboard-status.service';

export type GeneralSettingsTabType = 'hunter-agent' | 'meme-star' | 'others';

@Component({
    selector: 'app-general-settings',
    standalone: true,
    imports: [CommonModule, SharedModule, HunterAgentSettingsComponent, MemeStarSettingsComponent],
    templateUrl: './general-settings.component.html',
    styleUrls: ['./general-settings.component.less'],
})
export class GeneralSettingsComponent {
    @Input() tabType: GeneralSettingsTabType = 'hunter-agent';

    updatingAllowFollowers = false;

    constructor(
        public walletStatusService: WalletStatusService,
        private commonService: CommonService,
        private myProfileService: MyProfileService,
        private memeDashboardService: MemeDashboardService,
        private memeDashboardStatusService: MemeDashboardStatusService,
        public drawerRef: NzDrawerRef
    ) {}

    ngOnInit() {
        this.fetchMyWatchlistAgentInfo();
    }

    toggleAllowFollowers(status: boolean) {
        this.updatingAllowFollowers = true;

        this.myProfileService
            .updateUserProfile({ allow_follower: status })
            .then(userProfile => this.walletStatusService.userProfile$.next(userProfile))
            .catch(err => {
                this.commonService.errorMessageByResponse(err);
                this.walletStatusService.userProfile.allow_follower = !status;
            })
            .finally(() => (this.updatingAllowFollowers = false));
    }

    private fetchMyWatchlistAgentInfo() {
        this.memeDashboardService.getMyWatchListAgentInfo().subscribe({
            next: res => this.memeDashboardStatusService.myWatchlistAgentInfo$.next(res),
            error: err => this.commonService.errorMessageByResponse(err),
        });
    }
}
